"use client";

import { useMemo } from "react";
import styles from "../css/demographics.module.css";

export default function Demographics({ patientData = {} }) {
  const dob = useMemo(() => {
    if (!patientData.dateofbirth) return "";
    try {
      return new Date(patientData.dateofbirth).toISOString().split("T")[0];
    } catch {
      return "";
    }
  }, [patientData.dateofbirth]);

  return (
    <div className={styles.gridContainer}>
      {/* Column 1 */}
      <div className={styles.column}>
        <div className={styles.field}>
          <label>First Name</label>
          <div className={styles.value}>{patientData.firstname || ""}</div>
        </div>

        <div className={styles.field}>
          <label>ID Number</label>
          <div className={styles.value}>{patientData.idnumber || patientData.passportnumber || ""}</div>
        </div>

        <div className={styles.field}>
          <label>Gender</label>
          <div className={styles.value}>{patientData.gender || patientData.sex || ""}</div>
        </div>

        <div className={styles.field}>
          <label>Email</label>
          <div className={styles.value}>{patientData.email || ""}</div>
        </div>

        <div className={styles.field}>
          <label>Address</label>
          <div className={styles.value}>
            {patientData.homeaddress || patientData.deliveryaddress || ""}
          </div>
        </div>
      </div>

      {/* Column 2 */}
      <div className={styles.column}>
        <div className={styles.field}>
          <label>Last Name</label>
          <div className={styles.value}>{patientData.surname || ""}</div>
        </div>

        <div className={styles.field}>
          <label>Date of Birth</label>
          <div className={styles.value}>{dob}</div>
        </div>

        <div className={styles.field}>
          <label>Phone</label>
          <div className={styles.value}>{patientData.contactnumber || patientData.phonenumber || ""}</div>
        </div>

        <div className={styles.field}>
          <label>Medical Aid Provider</label>
          <div className={styles.value}>{patientData.medicalaidprovider || patientData.medicalaid || ""}</div>
        </div>

        <div className={styles.field}>
          <label>Medical Aid Number</label>
          <div className={styles.value}>{patientData.medicalaidnumber || ""}</div>
        </div>
      </div>
    </div>
  );
}